import { TagGroupInfo } from './vo/tag-group-info.model';
import { TagInfo } from './vo/tag-info.model';
/**
 * タグ管理画面の値を管理するクラス
 *
 * @export KYMW4600Model
 * @class KYMW4600Model
 */
export class KYMW4600Model {
  // タググループ名(新規登録用)
  public newTagGroupName = '';
  // タグ名(新規登録用)
  public newTagName = '';

  // タググループ一覧 編集前
  public tagGroupListOrigin: TagGroupInfo[] = [];
  // タグ一覧 編集前
  public tagListOrigin: TagInfo[] = [];

  // タググループ一覧 編集用
  public tagGroupListForEdit: TagGroupInfo[] = [];
  // タグ一覧 編集用
  public tagListForEdit: TagInfo[] = [];

  /**
   * 登録タグ情報
   *
   * @memberof KYMW4600Model
   */
  get registTags() {
    return this.tagListForEdit.filter(_t => !/^\d{8}$/.test(_t.tagId));
  }

  /**
   * 削除タグ情報
   *
   * @memberof KYMW4600Model
   */
  get deleteTags() {
    const keepTags = this.tagListForEdit.map(_t => _t.tagId);
    return this.tagListOrigin.filter(_t => !keepTags.includes(_t.tagId));
  }

  /**
   * 更新タグ情報
   *
   * @memberof KYMW4600Model
   */
  get updateTags() {
    return this.tagListForEdit.filter(_t =>
      this.tagListOrigin.find(
        _o => _o.tagId === _t.tagId && _o.tagName !== _t.tagName
      )
    );
  }

  /**
   * 登録タググループ情報
   *
   * @memberof KYMW4600Model
   */
  get registTagGroups() {
    return this.tagGroupListForEdit.filter(
      _t => !/^\d{8}$/.test(_t.tagGroupId)
    );
  }

  /**
   * 削除タググループ情報
   *
   * @memberof KYMW4600Model
   */
  get deleteTagGroups() {
    const holdTagGroups = this.tagGroupListForEdit.map(_t => _t.tagGroupId);
    return this.tagGroupListOrigin.filter(
      _t => !holdTagGroups.includes(_t.tagGroupId)
    );
  }

  /**
   * 更新タググループ情報
   *
   * @memberof KYMW4600Model
   */
  get updateTagGroups() {
    return this.tagGroupListForEdit.filter(_t =>
      this.tagGroupListOrigin.find(
        _o => _o.tagGroupId === _t.tagGroupId && !this.equalsTags(_t, _o)
      )
    );
  }

  /**
   * タググループ間の設定済みタグの等価判定
   *
   * @param {TagGroupInfo} a
   * @param {TagGroupInfo} b
   * @memberof KYMW4600Model
   */
  private equalsTags(a: TagGroupInfo, b: TagGroupInfo) {
    const aList = a.tags.map(_a => _a.tagId);
    const bList = b.tags.map(_b => _b.tagId);
    let res = true;
    aList.forEach(_a => {
      if (!bList.includes(_a)) res = false;
    });
    bList.forEach(_b => {
      if (!aList.includes(_b)) res = false;
    });
    return res;
  }

  /**
   * タググループ設定済みタグのID置き換え
   *
   * @param oldId
   * @param newId
   * @memberof KYMW4600Model
   */
  public setNewId(oldId: string, newId: string) {
    this.tagGroupListForEdit.forEach(_g =>
      _g.tags.filter(_t => oldId === _t.tagId).forEach(_t => (_t.tagId = newId))
    );
  }
}
